import { Injectable } from "@angular/core";
import { Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { map, Observable, take } from "rxjs";
import { AuthService } from "../services/auth/auth.service";

@Injectable({
    providedIn: 'root'
})

export class AuthGuard  {
    constructor (private _authService: AuthService, private _router: Router) {

    }

    canActivate(): boolean | Observable<boolean> {
        return this._authService.isLoggedIn().pipe(take(1), map(isLoggedIn => {
            if (!isLoggedIn) {
                this._router.navigate(['/login']);
                return false;
            }
            return true;
        }))
    }
}